import { LogoMark } from "@baze/brand";
import { t } from "@/i18n/id";

/** Branded boot splash (same markup as the inline splash in index.html → no flash). */
export function Splash() {
  return (
    <div className="fixed inset-0 grid place-items-center bg-paper" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-4">
        <LogoMark className="size-14 motion-safe:animate-pulse" aria-hidden="true" title="" />
        <span className="sr-only">{t.splash.loading}</span>
      </div>
    </div>
  );
}
